import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Observable, Subscription, combineLatest, forkJoin, map, of, tap } from 'rxjs';
import { ConfirmDialogComponent, DEFAULT_SNACKBAR_CONFIG, OrganizationService } from 'src/app/@shared';
import { Division, DivisionService, EditIntegrationDialogComponent, SettingsService } from '../../..';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ManageProvidersDialogComponent } from '../manage-providers-dialog/manage-providers-dialog.component';

@Component({
  selector: 'app-admin-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss'],
})
export class AdminIntegrationComponent<TDivision extends Division> implements OnInit {
  public integrations: any = [];

  // AI Automation is shown as one card with two integration-level switches
  // (copy = aiautomation, montage = montageautomation) plus Manage Providers.
  public aiCopyIntegration: any;
  public aiMontageIntegration: any;
  public otherIntegrations: any[] = [];

  constructor(
    private settingsService: SettingsService,
    private dialog: MatDialog, private matSnackBar: MatSnackBar) { }

  ngOnInit() {
    this.getIntegrations();
  }

  getIntegrations() {
    this.settingsService.getIntegrations().subscribe((res: any) => {
      this.integrations = res;
      this.createIntegrations(['aiautomation', 'montageautomation', 'montagebuilder', 'retailercomments']);
      this.splitIntegrations();
    });
  }

  private splitIntegrations() {
    const list = this.integrations || [];
    this.aiCopyIntegration = list.find((i: any) => i.ClientKey === 'aiautomation');
    this.aiMontageIntegration = list.find((i: any) => i.ClientKey === 'montageautomation');
    this.otherIntegrations = list.filter((i: any) => i.ClientKey !== 'aiautomation' && i.ClientKey !== 'montageautomation');
  }

  openManageProviders(): void {
    this.dialog.open(ManageProvidersDialogComponent, {
      width: '60%',
      maxWidth: '760px',
      maxHeight: '90vh',
    });
  }

  createIntegrations(integrationNames: string[]) {
    if (!this.integrations) this.integrations = [];
    if (integrationNames && integrationNames.length > 0) {
      for (let index = 0; index <= integrationNames.length - 1; index++) {
        const integ = this.integrations.find((i: any) => i.ClientKey === integrationNames[index]);
        if (!integ) {
          if (integrationNames[index] === 'aiautomation') {
            this.creaetAIAutomation();
          } else if (integrationNames[index] === 'montageautomation') {
            this.createMontageAutomation();
          } else if (integrationNames[index] === 'montagebuilder') {
            this.creaetmontageBuilder();
          } else if (integrationNames[index] === 'retailercomments') {
            this.createRetailerComments();
          }
        }
      }
    }
  }

  creaetAIAutomation() {
    const aiIntegration = {
      AIClientKey: "",
      ClientId: "",
      ClientKey: "aiautomation",
      Endpoint: "",
      IntegrationName: "IA Automation",
      Label: "Integration",
      OrganizationName: "",
      PartitionKey: "Integration",
      Status: false,
      Subscriptions: "",
      TemplateId: ""
    }
    this.integrations.push(aiIntegration);
  }

  createMontageAutomation() {
    const montageAutomation = {
      AIClientKey: "",
      ClientId: "",
      ClientKey: "montageautomation",
      Endpoint: "",
      IntegrationName: "Montage Automation",
      Label: "Integration",
      OrganizationName: "",
      PartitionKey: "Integration",
      Status: false,
      Subscriptions: "",
      TemplateId: ""
    }
    this.integrations.push(montageAutomation);
  }

  creaetmontageBuilder() {
    const montageIntegration = {
      AIClientKey: "",
      ClientId: "",
      ClientKey: "montagebuilder",
      Endpoint: "",
      IntegrationName: "Montage Builder",
      Label: "Integration",
      OrganizationName: "",
      PartitionKey: "Integration",
      Status: false,
      Subscriptions: "",
      TemplateId: ""
    }
    this.integrations.push(montageIntegration);
  }

  createRetailerComments() {
    const montageIntegration = {
      AIClientKey: "",
      ClientId: "",
      ClientKey: "retailercomments",
      Endpoint: "",
      IntegrationName: "Commenting",
      Label: "Integration",
      OrganizationName: "",
      PartitionKey: "Integration",
      Status: false,
      Subscriptions: "",
      TemplateId: ""
    }
    this.integrations.push(montageIntegration);
  }

  openDialog(integration: any): void {
    const dialogRef = this.dialog.open(EditIntegrationDialogComponent, {
      width: '50%',
      data: { id: integration.Id }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getIntegrations();
      }
    });
  }

  updateStatus(event: any, currentData: any) {
    if (!currentData) return;
    const intData = {
      Id: currentData.Id,
      ClientKey: currentData.ClientKey,
      IntegrationName: currentData.IntegrationName,
      Status: event.checked,
      ClientId: currentData.ClientId,
      AIClientKey: currentData.AIClientKey,
      Subscriptions: currentData.Subscriptions,
      OrganizationName: currentData.OrganizationName,
      Endpoint: currentData.Endpoint,
      TemplateId: currentData.TemplateId,
    }
    this.settingsService.updateIntegration(intData, currentData.Id).subscribe({
      next: (response) => {
        this.getIntegrations();
      },
      error: (error) => {
        if (error.status === 400) {
          const apiValidations: any = error.error;
          this.matSnackBar.open(apiValidations, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
        }
      }
    });
  }
}
